import React from 'react';
import { useParams } from 'react-router';
import { CpSpaceTabPreview } from './cp-space-tab-preview';

export const CpSpaceTabPage: React.FC = () => {
  const { projectId, spaceId, spaceTabId } =
    useParams<{
      projectId: string;
      spaceId: string;
      spaceTabId: string;
    }>();

  return (
    <CpSpaceTabPreview
      projectId={Number(projectId)}
      spaceId={Number(spaceId)}
      spaceTabId={Number(spaceTabId)}
    />
  );
};
